import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IUploadContext } from './upload-data.service';

export const UPLOAD_WIZARD:string = 'upload';
export const UPLOAD_STEP1:string = 'step1';
export const UPLOAD_STEP2:string = 'step2';
export const UPLOAD_STEP3:string = 'step3';

export interface IUploadModel {
  file?:File;
  uploadContext?:IUploadContext;
  backupUploadContext?:IUploadContext;
  context?:{ [ key:string ]:any };
  sheetName?:string;
}

@Injectable()
export class UploadService {
  private _model:IUploadModel = {};
  private subject:BehaviorSubject<IUploadModel> = new BehaviorSubject({});
  public modelChanges:Observable<IUploadModel> = this.subject.asObservable();

  constructor() {
    /**/
  }

  public get model():IUploadModel {
    return this._model;
  }

  public set model(model:IUploadModel) {
    this._model = model;
    this.subject.next(this._model);
  }

  public get selectedSheetName():string {
    return this._model.sheetName || this._model.uploadContext?.data?.sheetName;
  }
}